import { ENotAvailableModalTypes } from '../../actions/notAvailableModal';
import { INotAvailableModal } from '../../types/notAvailableModal';
import { TReduxActions } from '../../types/redux';

const defaultState: INotAvailableModal = {
  isOpen: false,
  offer: null,
  phone: '',
};

export function notAvailableModalReducer(
  state: INotAvailableModal = defaultState,
  action: TReduxActions,
): INotAvailableModal {
  switch (action.type) {
    case ENotAvailableModalTypes.Open: {
      return {
        ...state,
        isOpen: true,
        offer: action.payload.offer,
        phone: action.payload.phone,
      };
    }

    case ENotAvailableModalTypes.Close: {
      return {
        ...state,
        isOpen: false,
        offer: null,
        phone: '',
      };
    }
  }

  return state;
}
